import React, { useState, useEffect } from 'react' 
import axios from "axios";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import swal from "sweetalert";
import { confirmAlert } from "react-confirm-alert"; // Import
import { Link , useNavigate} from 'react-router-dom';

export default function FaqList() {
  const nav = useNavigate()
  console.log('start now')
  const [faqList, setFaqList] = useState([]);
  useEffect(() => {
    getFaqList();
  }, []);

  const getFaqList = async () => {
    await axios
      .get(process.env.REACT_APP_API_KEY + "api/admin/faq-list",
      {
        headers: {
        "Content-type": "Application/json",
        "Authorization": localStorage.getItem("token")
        }   
      }).then(function (response) {  
        //Check for Authorized
        if(response.data.code == 403){
          localStorage.clear();
          nav('/admin/login');
        }

        console.log("response.data => ", response.data);
        setFaqList(response.data.data);
        
      }).catch(function (error) {        
        console.log(error);
      });
  };


  //Update status
  const handleClick = async (event) => {
    confirmAlert({
      title: "Confirm to Action",
      message: "Are you sure to update status of this FAQ.",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            await axios.get(process.env.REACT_APP_API_KEY+'api/admin/faq-status/'+event,
              {
                headers: {
                "Content-type": "Application/json",
                "Authorization": localStorage.getItem("token")
                }   
              }
              ).then(function (response) {
                //Check for Authorized
                console.log("======--->", response)
                if(response.data.code == 403){
                  localStorage.clear();
                  nav('/admin/login');
                }
              if(response.status===200)
              {
                swal({
                  title: "Status",
                  text: "Status Updated Successfully!",
                  icon: "success",
                  button: "Okay",
                });
              }
              getFaqList();
            })
            .catch(function (error) {
              console.log(error);
            });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

    const deleteFaq = async (id) => {
    
      confirmAlert({
        title: "Confirm to Delete",
        message: "Are you sure to delete FAQ.",
        buttons: [
          {
            label: "Yes",
            onClick: async () => {
              await axios
                .get(process.env.REACT_APP_API_KEY+"api/admin/faq-delete/" + id,
                {headers: {
                  "Content-type": "Application/json",
                  "Authorization": localStorage.getItem("token")
                  }   
                }
                )
                .then(function (response) {
                  //Check for Authorized
                  if(response.data.code == 403){
                    localStorage.clear();
                    nav('/admin/login');
                  }

                  if (response.data.code == 200){
                    console.log(">>>>",response);
                    swal({
                      title: "Wow!",
                      text: response.data.message,
                      icon: "success",
                      button: "Okay",
                    });
                    getFaqList();
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    };

  //initialize datatable
  useEffect(() => {
    setTimeout(function () {
      $("#myTable").DataTable({
        bDestroy: true,
        fixedHeader: true,
        pagingType: "full_numbers",
        pageLength: 10,
        processing: true,
        dom: "Bfrtip",
  
        select: true,
      });
    }, 1000);
  }, []);

    return (
    <div class="body flex-grow-1 px-3">
          <div className="wrapper">
            <div className="content-wrapper">
              <h5 className="my3">
                FAQ Management
                <Link className="btn btn-primary " to="/admin/faq-add">Add FAQ</Link>
              </h5>
              <table id="myTable" className="table table-striped my-3">
                <thead>
                  <tr>
                    <th scope="col" style={{"width" : "10%"}}>#</th>
                    <th scope="col" style={{"width" : "30%"}}>Question</th>
                    <th scope="col" style={{"width" : "50%"}}>Answere</th>
                    <th scope="col" style={{"width" : "10%"}}>Action(s)</th>
                  </tr>
                </thead>
                <tbody>
                  {faqList.map((value, index) => (
                    
                    <tr>
                      <td>{++index}</td>
                      <td>{value.question}</td>
                      <td>{(value.answere).substring(0, 200)}</td>
                      <td style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
                      <Link className="btn btn-success custom-btn" to={{ pathname: "/admin/faq-edit" }} state={{ id: value.get_faq.id }} >
                        <i className="fas fa-edit" title="Edit"></i>
                      </Link>
                      &nbsp;
                    <button className="btn btn-info custom-btn" onClick={() => { handleClick(value.get_faq.id); }} title={value.status}>
                    <i className={value.status==='active' ? 'fas fa-toggle-on' : 'fas fa-toggle-off'}></i>
                    </button>
                    
                    &nbsp;
                    <button type="button" className="btn btn-danger custom-btn"
                      onClick={() => {
                        deleteFaq(value.get_faq.id);
                      }}
                      title="Delete"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                      </td>
                    </tr>
                  ))}  
                </tbody>
              </table>
            </div>     
          </div>
        </div>
    )
  }
  